import { AuditLiveMention, toDateTimeStr, toTimestamp } from '@mi-front/core';
import LinkIcon from '@mui/icons-material/Link';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { useCopyQuickShareURLFromParams } from '../../../../../hooks/selection/useSelectionActions';

const generateDescription = (code: string, description: string | null): string => {
  let text = `${code}`;

  if (description !== null) {
    text += ` - ${description}`;
  }

  if (text.length > 30) {
    text = text.slice(0, 30) + '...';
  }

  return text;
};

export function LiveShareBtn(p: { liveMention: AuditLiveMention }) {
  const { liveMention } = p;
  const { $t } = useIntl();
  const copyQuickShareURLFromParams = useCopyQuickShareURLFromParams();

  const generateUrlToShare = () => {
    copyQuickShareURLFromParams({
      $t: $t,
      startTime: liveMention.datetime,
      endTime: toDateTimeStr(toTimestamp(liveMention.datetime) + 90000),
      title: generateDescription(liveMention.name, liveMention.description),
    });
  };

  return (
    <Button
      size="small"
      sx={{ marginTop: 0.5, marginLeft: 0.5 }}
      onClick={generateUrlToShare}
      startIcon={<LinkIcon />}
    >
      {$t({
        id: 'logger.streamScreen.selectionMenu.copyQuickShare',
        defaultMessage: 'Copiar URL Quick Share',
      })}
    </Button>
  );
}
